module.exports = require("classnames");


/*****************
 ** WEBPACK FOOTER
 ** external "classnames"
 ** module id = 32
 ** module chunks = 0
 **/